/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.2.2.0 (NJsonSchema v10.1.4.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

export class AchievementsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    list(): Promise<AchievementModel[]> {
        let url_ = this.baseUrl + "/api/Achievements";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<AchievementModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AchievementModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AchievementModel[]>(<any>null);
    }

    create(request: CreateAchievementRequest): Promise<AchievementModel> {
        let url_ = this.baseUrl + "/api/Achievements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<AchievementModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AchievementModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AchievementModel>(<any>null);
    }

    listAll(): Promise<AchievementModel[]> {
        let url_ = this.baseUrl + "/api/Achievements/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListAll(_response);
        });
    }

    protected processListAll(response: AxiosResponse): Promise<AchievementModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AchievementModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AchievementModel[]>(<any>null);
    }

    get(id: string): Promise<AchievementModel> {
        let url_ = this.baseUrl + "/api/Achievements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AchievementModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AchievementModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AchievementModel>(<any>null);
    }

    update(achievementId: string, request: UpdateAchievementRequest): Promise<AchievementModel> {
        let url_ = this.baseUrl + "/api/Achievements/{achievementId}";
        if (achievementId === undefined || achievementId === null)
            throw new Error("The parameter 'achievementId' must be defined.");
        url_ = url_.replace("{achievementId}", encodeURIComponent("" + achievementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<AchievementModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AchievementModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AchievementModel>(<any>null);
    }

    delete(achievementId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Achievements/{achievementId}";
        if (achievementId === undefined || achievementId === null)
            throw new Error("The parameter 'achievementId' must be defined.");
        url_ = url_.replace("{achievementId}", encodeURIComponent("" + achievementId));
        url_ = url_.replace(/[?&]$/, "");



        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class ActiveDirectoryUsersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    list(): Promise<ActiveDirectoryUserModel[]> {
        let url_ = this.baseUrl + "/api/ActiveDirectoryUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<ActiveDirectoryUserModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActiveDirectoryUserModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActiveDirectoryUserModel[]>(<any>null);
    }
}

export class ConfigurationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    get(): Promise<ConfigurationModel> {
        let url_ = this.baseUrl + "/api/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ConfigurationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigurationModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigurationModel>(<any>null);
    }

    update(request: UpdateConfigurationRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/configuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class PurchasesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    list(): Promise<PurchaseModel[]> {
        let url_ = this.baseUrl + "/api/Purchases";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<PurchaseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PurchaseModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaseModel[]>(<any>null);
    }

    create(createPurchaseRequest: CreatePurchaseRequest): Promise<PurchaseModel> {
        let url_ = this.baseUrl + "/api/Purchases";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createPurchaseRequest);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<PurchaseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchaseModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaseModel>(<any>null);
    }

    listAll(): Promise<PurchaseModel[]> {
        let url_ = this.baseUrl + "/api/Purchases/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processListAll(_response);
        });
    }

    protected processListAll(response: AxiosResponse): Promise<PurchaseModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PurchaseModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaseModel[]>(<any>null);
    }

    get(id: string): Promise<PurchaseModel> {
        let url_ = this.baseUrl + "/api/Purchases/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PurchaseModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PurchaseModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PurchaseModel>(<any>null);
    }

    delete(id: string) : Promise<AxiosResponse> {
        return this.instance.delete(`/api/Purchases/${id}`);
    }

    markAsProcessed(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Purchases/{id}:mark-as-processed";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMarkAsProcessed(_response);
        });
    }

    protected processMarkAsProcessed(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: response.data as Blob, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class RewardsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    list(): Promise<RewardModel[]> {
        let url_ = this.baseUrl + "/api/Rewards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<RewardModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RewardModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RewardModel[]>(<any>null);
    }

    create(
      name: string | null | undefined,
      description: string | null | undefined,
      points: number | undefined,
      showMessageBox: boolean,
      image: FileParameter | null | undefined
    ): Promise<RewardModel> {
        let url_ = this.baseUrl + "/api/Rewards";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (points === null || points === undefined)
            throw new Error("The parameter 'points' cannot be null.");
        else
            content_.append("Points", points.toString());
        content_.append("ShowMessageBox", showMessageBox ? "true" : "false");
        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<RewardModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RewardModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RewardModel>(<any>null);
    }

    update(
      rewardId: string,
      name: string | null | undefined,
      description: string | null | undefined,
      points: number | undefined,
      showMessageBox: boolean,
      image: FileParameter | null | undefined): Promise<RewardModel> {
        let url_ = this.baseUrl + "/api/Rewards/{rewardId}";
        if (rewardId === undefined || rewardId === null)
            throw new Error("The parameter 'rewardId' must be defined.");
        url_ = url_.replace("{rewardId}", encodeURIComponent("" + rewardId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (points === null || points === undefined)
            throw new Error("The parameter 'points' cannot be null.");
        else
            content_.append("Points", points.toString());
        content_.append("ShowMessageBox", showMessageBox ? "true" : "false");

        if (image !== null && image !== undefined)
            content_.append("Image", image.data, image.fileName ? image.fileName : "Image");

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<RewardModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RewardModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RewardModel>(<any>null);
    }

    delete(rewardId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/Rewards/{rewardId}";
        if (rewardId === undefined || rewardId === null)
            throw new Error("The parameter 'rewardId' must be defined.");
        url_ = url_.replace("{rewardId}", encodeURIComponent("" + rewardId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class TeamMemberClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    me(): Promise<TeamMemberModel> {
        let url_ = this.baseUrl + "/api/TeamMember/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processMe(_response);
        });
    }

    protected processMe(response: AxiosResponse): Promise<TeamMemberModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TeamMemberModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamMemberModel>(<any>null);
    }

    list(includeDeleted?: boolean): Promise<TeamMemberModel[]> {
        let url_ = this.baseUrl + `/api/TeamMember?includeDeleted=${encodeURIComponent(includeDeleted ?? false)}`;
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<TeamMemberModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TeamMemberModel.fromJS(item));
            }
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamMemberModel[]>(<any>null);
    }

    create(request: CreateTeamMemberRequest): Promise<TeamMemberModel> {
        let url_ = this.baseUrl + "/api/TeamMember";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<TeamMemberModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TeamMemberModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamMemberModel>(<any>null);
    }

    update(teamMemberId: string, request: UpdateTeamMemberRequest): Promise<TeamMemberModel> {
        let url_ = this.baseUrl + "/api/TeamMember/{teamMemberId}";
        if (teamMemberId === undefined || teamMemberId === null)
            throw new Error("The parameter 'achievementId' must be defined.");
        url_ = url_.replace("{teamMemberId}", encodeURIComponent("" + teamMemberId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<TeamMemberModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TeamMemberModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamMemberModel>(<any>null);
    }

    delete(teamMemberId: string): Promise<TeamMemberModel> {
        let url_ = this.baseUrl + "/api/TeamMember/{teamMemberId}";
        if (teamMemberId === undefined || teamMemberId === null)
            throw new Error("The parameter 'achievementId' must be defined.");
        url_ = url_.replace("{teamMemberId}", encodeURIComponent("" + teamMemberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<TeamMemberModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TeamMemberModel.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamMemberModel>(<any>null);
    }

    clearPoints(request: SetAllPointsRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/BulkAction/setAllAllocatePoints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processClearPoints(_response);
        });
    }

    protected processClearPoints(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            return Promise.resolve<void>(<any>null);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class AchievementModel implements IAchievementModel {
    teamMemberId?: string;
    teamMemberName?: string | undefined;
    achievementId?: string;
    name?: string | undefined;
    description?: string | undefined;
    achievedAtUtc?: string;
    pointsEarned?: number;
    awardedByTeamMemberId?: string;
    awardedByTeamMemberName?: string | undefined;

    constructor(data?: IAchievementModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamMemberId = _data["teamMemberId"];
            this.teamMemberName = _data["teamMemberName"];
            this.achievementId = _data["achievementId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.achievedAtUtc = _data["achievedAtUtc"];
            this.pointsEarned = _data["pointsEarned"];
            this.awardedByTeamMemberId = _data["awardedByTeamMemberId"];
            this.awardedByTeamMemberName = _data["awardedByTeamMemberName"];
        }
    }

    static fromJS(data: any): AchievementModel {
        data = typeof data === 'object' ? data : {};
        let result = new AchievementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamMemberId"] = this.teamMemberId;
        data["teamMemberName"] = this.teamMemberName;
        data["achievementId"] = this.achievementId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["achievedAtUtc"] = this.achievedAtUtc;
        data["pointsEarned"] = this.pointsEarned;
        data["awardedByTeamMemberId"] = this.awardedByTeamMemberId;
        data["awardedByTeamMemberName"] = this.awardedByTeamMemberName;
        return data;
    }
}

export interface IAchievementModel {
    teamMemberId?: string;
    teamMemberName?: string | undefined;
    achievementId?: string;
    name?: string | undefined;
    description?: string | undefined;
    achievedAtUtc?: string;
    pointsEarned?: number;
    awardedByTeamMemberId?: string;
    awardedByTeamMemberName?: string | undefined;
}

export class CreateAchievementRequest implements ICreateAchievementRequest {
    teamMemberId!: string;
    name!: string;
    description!: string;
    pointsEarned!: number;
    awardedByTeamMemberId?: string;

    constructor(data?: ICreateAchievementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamMemberId = _data["teamMemberId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.pointsEarned = _data["pointsEarned"];
            this.awardedByTeamMemberId = _data["awardedByTeamMemberId"];
        }
    }

    static fromJS(data: any): CreateAchievementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAchievementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamMemberId"] = this.teamMemberId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["pointsEarned"] = this.pointsEarned;
        data["awardedByTeamMemberId"] = this.awardedByTeamMemberId;
        return data;
    }
}

export interface ICreateAchievementRequest {
    teamMemberId: string;
    name: string;
    description: string;
    pointsEarned: number;
    awardedByTeamMemberId?: string;
}

export class UpdateAchievementRequest implements IUpdateAchievementRequest {
    name!: string;
    description!: string;
    pointsEarned!: number;
    awardedByTeamMemberId?: string;

    constructor(data?: IUpdateAchievementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.pointsEarned = _data["pointsEarned"];
            this.awardedByTeamMemberId = _data["awardedByTeamMemberId"];
        }
    }

    static fromJS(data: any): UpdateAchievementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAchievementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["pointsEarned"] = this.pointsEarned;
        data["awardedByTeamMemberId"] = this.awardedByTeamMemberId;
        return data;
    }
}

export interface IUpdateAchievementRequest {
    name: string;
    description: string;
    pointsEarned: number;
    awardedByTeamMemberId?: string;
}

export class ActiveDirectoryUserModel implements IActiveDirectoryUserModel {
    fullName?: string | undefined;
    givenName?: string | undefined;
    email?: string | undefined;
    surname?: string | undefined;
    id?: string | undefined;

    constructor(data?: IActiveDirectoryUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"];
            this.givenName = _data["givenName"];
            this.email = _data["email"];
            this.surname = _data["surname"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ActiveDirectoryUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveDirectoryUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName;
        data["givenName"] = this.givenName;
        data["email"] = this.email;
        data["surname"] = this.surname;
        data["id"] = this.id;
        return data;
    }
}

export interface IActiveDirectoryUserModel {
    fullName?: string | undefined;
    givenName?: string | undefined;
    email?: string | undefined;
    surname?: string | undefined;
    id?: string | undefined;
}

export class ConfigurationModel implements IConfigurationModel {
    welcomeMessage?: string | undefined;

    constructor(data?: IConfigurationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.welcomeMessage = _data["welcomeMessage"];
        }
    }

    static fromJS(data: any): ConfigurationModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigurationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["welcomeMessage"] = this.welcomeMessage;
        return data;
    }
}

export interface IConfigurationModel {
    welcomeMessage?: string | undefined;
}

export class UpdateConfigurationRequest implements IUpdateConfigurationRequest {
    welcomeMessage?: string | undefined;

    constructor(data?: IUpdateConfigurationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.welcomeMessage = _data["welcomeMessage"];
        }
    }

    static fromJS(data: any): UpdateConfigurationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConfigurationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["welcomeMessage"] = this.welcomeMessage;
        return data;
    }
}

export interface IUpdateConfigurationRequest {
    welcomeMessage?: string | undefined;
}

export class PurchaseModel implements IPurchaseModel {
    purchaseId?: string;
    quantity?: number;
    rewardName?: string | undefined;
    rewardDescription?: string | undefined;
    purchasedAtUtc?: string;
    points?: number;
    teamMemberId?: string;
    teamMemberName?: string | undefined;
    isProcessed?: boolean;
    processedAtUtc?: string | undefined;
    message: string | undefined;

    constructor(data?: IPurchaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.purchaseId = _data["purchaseId"];
            this.quantity = _data["quantity"];
            this.rewardName = _data["rewardName"];
            this.rewardDescription = _data["rewardDescription"];
            this.purchasedAtUtc = _data["purchasedAtUtc"];
            this.points = _data["points"];
            this.teamMemberId = _data["teamMemberId"];
            this.teamMemberName = _data["teamMemberName"];
            this.isProcessed = _data["isProcessed"];
            this.processedAtUtc = _data["processedAtUtc"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PurchaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["purchaseId"] = this.purchaseId;
        data["quantity"] = this.quantity;
        data["rewardName"] = this.rewardName;
        data["rewardDescription"] = this.rewardDescription;
        data["purchasedAtUtc"] = this.purchasedAtUtc;
        data["points"] = this.points;
        data["teamMemberId"] = this.teamMemberId;
        data["teamMemberName"] = this.teamMemberName;
        data["isProcessed"] = this.isProcessed;
        data["processedAtUtc"] = this.processedAtUtc;
        data["message"] = this.message;
        return data;
    }
}

export interface IPurchaseModel {
    purchaseId?: string;
    quantity?: number;
    rewardName?: string | undefined;
    rewardDescription?: string | undefined;
    purchasedAtUtc?: string;
    points?: number;
    teamMemberId?: string;
    teamMemberName?: string | undefined;
    isProcessed?: boolean;
    processedAtUtc?: string | undefined;
    message: string | undefined;
}

export class CreatePurchaseRequest implements ICreatePurchaseRequest {
    rewardId!: string;
    quantity!: number;
    message!: string;

    constructor(data?: ICreatePurchaseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rewardId = _data["rewardId"];
            this.quantity = _data["quantity"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreatePurchaseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePurchaseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardId"] = this.rewardId;
        data["quantity"] = this.quantity;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreatePurchaseRequest {
    rewardId: string;
    quantity: number;
    message: string;
}

export class RewardModel implements IRewardModel {
    rewardId?: string;
    name?: string | undefined;
    description?: string | undefined;
    points?: number;
    imageUrl?: string | undefined;
    showMessageBox!: boolean;

    constructor(data?: IRewardModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rewardId = _data["rewardId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.points = _data["points"];
            this.imageUrl = _data["imageUrl"];
            this.showMessageBox = _data["showMessageBox"];
        }
    }

    static fromJS(data: any): RewardModel {
        data = typeof data === 'object' ? data : {};
        let result = new RewardModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rewardId"] = this.rewardId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["points"] = this.points;
        data["imageUrl"] = this.imageUrl;
        data["showMessageBox"] = this.showMessageBox;
        return data;
    }
}

export interface IRewardModel {
    rewardId?: string;
    name?: string | undefined;
    description?: string | undefined;
    points?: number;
    imageUrl?: string | undefined;
    showMessageBox: boolean;
}

export class TeamMemberModel implements ITeamMemberModel {
    teamMemberId?: string;
    name?: string | undefined;
    availablePoints?: number;
    availablePointsToAllocate?: number;
    isDeleted: boolean = false;
    email?: string | undefined;
    slackUserId?: string | undefined;

    constructor(data?: ITeamMemberModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamMemberId = _data["teamMemberId"];
            this.name = _data["name"];
            this.availablePoints = _data["availablePoints"];
            this.availablePointsToAllocate = _data["availablePointsToAllocate"];
            this.email = _data["email"];
            this.slackUserId = _data["slackUserId"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): TeamMemberModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamMemberModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamMemberId"] = this.teamMemberId;
        data["name"] = this.name;
        data["availablePoints"] = this.availablePoints;
        data["availablePointsToAllocate"] = this.availablePointsToAllocate;
        data["email"] = this.email;
        data["slackUserId"] = this.slackUserId;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface ITeamMemberModel {
    teamMemberId?: string;
    name?: string | undefined;
    availablePoints?: number;
    availablePointsToAllocate?: number;
    email?: string | undefined;
    slackUserId?: string | undefined;
    isDeleted: boolean;
}

export interface ICreateTeamMemberRequest {
    activeDirectoryId: string;
    name: string;
    email: string;
}

export class CreateTeamMemberRequest implements ICreateTeamMemberRequest {
    activeDirectoryId!: string;
    name!: string;
    email!: string;
    slackUserId!: string;

    constructor(data?: ICreateTeamMemberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeDirectoryId = _data["activeDirectoryId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.slackUserId = _data["slackUserId"];
        }
    }

    static fromJS(data: any): CreateTeamMemberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTeamMemberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeDirectoryId"] = this.activeDirectoryId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["slackUserId"] = this.slackUserId;
        return data;
    }
}

export interface IUpdateTeamMemberRequest {
    availablePoints: number;
    availablePointsToAllocate: number;
    slackUserId: string;
}

export class UpdateTeamMemberRequest implements IUpdateTeamMemberRequest {
    availablePoints!: number;
    availablePointsToAllocate!: number;
    slackUserId!: string;

    constructor(data?: IUpdateTeamMemberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.availablePoints = _data["availablePoints"];
            this.availablePointsToAllocate = _data["availablePointsToAllocate"];
            this.slackUserId = _data["slackUserId"];
        }
    }

    static fromJS(data: any): UpdateTeamMemberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTeamMemberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["availablePoints"] = this.availablePoints;
        data["availablePointsToAllocate"] = this.availablePointsToAllocate;
        data["slackUserId"] = this.slackUserId;
        return data;
    }
}

export interface IDeleteTeamMemberRequest {
    teamMemberId: string;
}

export class DeleteTeamMemberRequest implements IDeleteTeamMemberRequest {
    teamMemberId!: string;

    constructor(data?: IUpdateTeamMemberRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.teamMemberId = _data["teamMemberId"];
        }
    }

    static fromJS(data: any): DeleteTeamMemberRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTeamMemberRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["teamMemberId"] = this.teamMemberId;
        return data;
    }
}

export class SetAllPointsRequest implements ISetAllPointsRequest {
    pointTotal!: number;

    constructor(data?: ISetAllPointsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pointTotal = _data["pointTotal"];
        }
    }

    static fromJS(data: any): SetAllPointsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetAllPointsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pointTotal"] = this.pointTotal;
        return data;
    }
}

export interface ISetAllPointsRequest {
    pointTotal: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
